import NoMunicipalityRoutes from 'js/vue-plugins/vue-router/routes/no-municipality'
import CustomNoMunicipalityRoutes from 'js/vue-plugins/vue-router/routes/custom-no-municipality'
import MunicipalityRoutes from 'js/vue-plugins/vue-router/routes/municipalities/index'
import PrivacyPolicyRoutes from 'js/vue-plugins/vue-router/routes/privacy-policy'
import SystemRoutes from 'js/vue-plugins/vue-router/routes/system'

import MapPublicRoutes from 'js/vue-plugins/vue-router/routes/municipalities/map-public-routes'
import PublicRoutes from 'js/vue-plugins/vue-router/routes/municipalities/public-routes'
import PrivateRoutes from 'js/vue-plugins/vue-router/routes/municipalities/private-routes'

/** Change loaded components for this app */
import Travels from 'js/pages/municipality-data-element/travels/index.js'
import NewBalance from 'js/pages/municipality-data/new-balance/index.js'

/**
 * Modifies the 'component' property of a nested route object.
 *
 * @param {Array<Object>} routesArray - The array of route objects (your core routes).
 * @param {string} parentPath - The 'path' value of the parent route (e.g., 'data').
 * @param {string} childName - The 'name' value of the child route
 * (e.g., 'municipality-data-travels').
 * @param {string} newComponentValue - The new value to set for the 'component' property.
 * @returns {boolean} - True if the modification was successful, false otherwise.
 */

function modifyRouteComponent(
  routesArray,
  parentPath,
  childName,
  newComponentValue
) {
  const parentObject = routesArray.find(item => item.path === parentPath)

  if (parentObject && Array.isArray(parentObject.children)) {
    const childToModify = parentObject.children.find(child => child.name === childName)

    if (childToModify) {
      childToModify.component = newComponentValue

      return true
    }
  }

  return false
}

modifyRouteComponent(PrivateRoutes, 'data', 'municipality-data-travels', Travels)
modifyRouteComponent(PrivateRoutes, 'data', 'municipality-data-balance', NewBalance)

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: {name: HOME_ROUTE}
  },
  ...normalizeRoutes(NoMunicipalityRoutes),
  ...normalizeRoutes(CustomNoMunicipalityRoutes),
  ...normalizeRoutes(MunicipalityRoutes),
  ...normalizeRoutes(PrivacyPolicyRoutes),
  ...normalizeRoutes(SystemRoutes),
  ...normalizeRoutes(MapPublicRoutes),
  ...normalizeRoutes(PublicRoutes),
  ...normalizeRoutes(PrivateRoutes)
]

export default routes
